import React, { useState } from "react";
import { CategoryItem } from "../../../interfaces/Catalogue";
import OrderItem from "./OrderItem/OrderItem";

interface OrderDetailsProps {
  categories: CategoryItem[];
  orderType: number;
  canEditQuantity: boolean;
  canApplyArticleDiscount: boolean;
  rewardClaimDisabled?: boolean;
  restaurantId?: number;
  userLoyalityPoints?: number;
  totalLoyaltyPtsConsomed?: number;
}

const OrderDetails = (props: OrderDetailsProps) => {
  const {
    categories,
    restaurantId,
    orderType,
    canEditQuantity,
    canApplyArticleDiscount,
    rewardClaimDisabled,
    userLoyalityPoints,
    totalLoyaltyPtsConsomed
  } = props;

  return (
    <div>
      {categories?.map((categoryItem, index) => (
        <OrderItem
          key={index}
          index={index}
          categoryItem={categoryItem}
          orderType={orderType}
          canApplyArticleDiscount={canApplyArticleDiscount}
          canEditQuantity={canEditQuantity}
          restaurantId={restaurantId}
          userLoyalityPoints={userLoyalityPoints}
          totalLoyaltyPtsConsomed={totalLoyaltyPtsConsomed}
          rewardClaimDisabled={rewardClaimDisabled}
        />
      ))}
    </div>
  );
};

export default OrderDetails;
